import { createSlice } from "@reduxjs/toolkit";

const cuentapagarState = {
  datacuentapagar: []
}

export const cuentaporpagarSlice = createSlice({
  name: "cuentaporpagar",
  initialState: cuentapagarState,
  reducers: {
    StoreCuentaPagarData: (state, actions) => {
      state.datacuentapagar = actions.payload;
    },
    ResetCuentaPagarData: () => cuentapagarState,
  }
});

export const { StoreCuentaPagarData, ResetCuentaPagarData } = cuentaporpagarSlice.actions;

export default cuentaporpagarSlice.reducer;
